'use client'
import Image from 'next/image.js';

import { sprinkles } from '@/style/landingPage/theme.css';
import * as styles from '@/style/landingPage/styles.css';

import selfyImg from '../../../public/images/landingPage/photos/banner/selfy.jpg';
import layingOnCouchImg from '../../../public/images/landingPage/photos/banner/laying-on-couch.jpg';
import outdoorPhotographyImg from '../../../public/images/landingPage/photos/banner/outdoor-photography.jpg';
import ladyUsingPhoneImg from '../../../public/images/landingPage/photos/banner/lady-using-phone.jpg';
import laundryImg from '../../../public/images/landingPage/photos/banner/laundry.jpg';
import virtualRealityImg from '../../../public/images/landingPage/photos/banner/virtual-reality.jpg';

export default function MobileBanner() {

  return (
    <section id='mobile-banner'>
      <div id='mobile-banner-grid'>
        <header className="top-middle-rows">
          <div className="top-column-content overlay-animation ending-animation">
            <Image priority loading="eager" 
              src={layingOnCouchImg}
              alt="Laying on the couch."
              placeholder="blur"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
          <aside className='top-column-content overlay-animation ending-animation'>
            <Image priority loading="eager" 
              src={selfyImg}
              alt="Selfy."
              placeholder="blur"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </aside>
          <div className="top-column-content overlay-animation ending-animation">
            {/* Image size is inconsistent */}
            <Image priority loading="eager" 
              src={outdoorPhotographyImg}
              alt="Outdoor photography."
              placeholder="blur"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
        </header>
        <section className="banner-content">
          <div className={sprinkles({ textAlign: 'center', color: 'white', gap: 'lg', paddingX: 'md', display: 'flex', height: 'full', justifyContent: 'center',  alignItems: 'center', flexDirection: 'column'})}
          >
            <header className="overlay-animation middle-animation">
              <h1 className={styles.mainHeading}>Device ownership <div className={sprinkles({ color: 'aqua',})}>reimagined</div></h1>
              <p className={`
                  ${sprinkles({
                    fontSize: {
                      mobile: 'md',
                      tablet: 'md',
                      desktop: 'md',
                      largeScreens: 'lg'
                    }
                  })}
                  ${{
                    fontWeight: '400',
                    lineHeight: 1.6,
                  }}
                `
              }>Kingfisher is now SquareTrade, delivering leading mobile and protection services across the world</p>
            </header>
            <div className="overlay-animation ending-animation">
              <a href="#intro-section"
                className={sprinkles({ backgroundColor: 'orange', color: 'navy', display: 'flex', alignItems: 'center', justifyContent: 'center' })}
                  style={{
                    border: 'none',
                    borderRadius: '50%',
                    width: '56px',
                    height: '56px',
                    cursor: 'pointer',
                  }}
                >
                  <svg width="11" height="11" viewBox="0 0 11 11" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.1875 -7.43313e-07L6.1875 8.36687L10.0306 4.52375L11 5.5L5.5 11L7.13262e-07 5.5L0.969375 4.53062L4.8125 8.36687L4.8125 -6.8321e-07L6.1875 -7.43313e-07Z" fill="#0E1942"/>
                  </svg>
              </a>
              </div>
          </div>
        </section>
 
        <footer className="bottom-middle-rows">
          <div className="bottom-column-content overlay-animation starting-animation">
            <Image priority loading="eager"
              src={laundryImg}
              alt="Laundry."
              placeholder="blur"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
          <div className="bottom-column-content overlay-animation starting-animation">
            <Image priority loading="eager"
              src={virtualRealityImg}
              alt="Virtual reality."
              placeholder="blur"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>

          <div className="bottom-column-content overlay-animation starting-animation">
              {/* Image size is inconsistent */}
            <Image priority loading="eager" 
              src={ladyUsingPhoneImg}
              alt="Lady using phone."
              placeholder="blur"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
        </footer>
      </div>
    </section>
  )
}